import axios from 'axios'
import { useUserStore } from '@/stores/userStore'
import { JAMS_BACKEND_API_URL, STAGE } from '@/env'

const apiClientAdmin = axios.create({
  baseURL: `${JAMS_BACKEND_API_URL}/${STAGE}`,
  timeout: 20000,
})

export const axiosInstanceAdmin = axios.create({
  baseURL: `${JAMS_BACKEND_API_URL}/${STAGE}`,
  timeout: 20000,
})

axiosInstanceAdmin.interceptors.request.use(
  (config) => {
    const userStore = useUserStore()

    config.headers['Authorization'] = `Bearer ${userStore.token}`

    // Add product ID and account for usage tracking
    const params = new URLSearchParams(config.params)
    
    // Always set product to 'jams' for JAMS admin calls
    params.set('product', 'jams')
    
    // Set account based on user role
    const role = userStore.role as string | null
    if (role && role.startsWith('client_')) {
      // Client users: use their juid
      if (userStore.juid) {
        params.set('account', userStore.juid)
      }
    } else {
      // Company users: use 'jazel'
      params.set('account', 'jazel')
    }
    
    config.params = params

    console.log(config)
    return config
  },
  (error) => Promise.reject(error)
)

axiosInstanceAdmin.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error)

    return Promise.reject(error)
  }
)

export default apiClientAdmin
